import produce from "immer";
import * as Action from "../actions/index";
export const initialState = {
  allUsers: null,
  backend: {
    usersList: null,
    selectedUser: null,
  },
};

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Action.GET_USERS:
        draft.backend.usersList = action.payload;
        break;
      case Action.DELETE_USER:
        const userIndex = draft.backend.usersList.findIndex(
          (el) => el.id === action.payload
        );
        draft.backend.usersList.splice(userIndex, 1);
        break;
      case Action.SELECT_USER:
        draft.backend.selectedUser = action.payload;
        break;
      default:
        return state;
    }
  });
export default reducer;
